module.exports = __webpack_public_path__ + "static/img/img_8.ae412a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/code/img_8.jpg
// module id = 115
// module chunks = 20